import { t } from 'i18next'

import type { CompradorEstadoCivilSchemaOutput } from '@/features/proposta/schemas/compradores/comprador-pf.schema'
import { EstadoCivilEnum } from '@/types/cliente'

type Issue = { message: string; path: string[] }
export class EstadoCivilVinculoValidator {
  constructor(private readonly params: CompradorEstadoCivilSchemaOutput) {}
  private estadoCivilIssue(): Issue {
    return {
      message: t('proposta:cadastro_compradores.steps.estado_civil.erro.estado_civil'),
      path: ['status'],
    }
  }
  private uniaoEstavelIssue(): Issue {
    return {
      message: t('proposta:cadastro_compradores.steps.estado_civil.erro.uniao_estavel'),
      path: ['uniaoEstavel'],
    }
  }
  private regimeCasamentoIssue(): Issue {
    return {
      message: t('proposta:cadastro_compradores.steps.estado_civil.erro.regime_casamento'),
      path: ['regimeCasamento'],
    }
  }

  validar(): Issue | null {
    const { status, uniaoEstavel, regimeCasamento } = this.params
    if (!status) return this.estadoCivilIssue()
    if (status !== EstadoCivilEnum.CivilCasado) return uniaoEstavel ? null : this.uniaoEstavelIssue()
    if (!regimeCasamento) return this.regimeCasamentoIssue()
    return null
  }
}
